export default __webpack_public_path__ + "static/media/flyer.50a72f47.jpg";